export default ({router, next}: any) => {
	const {currentRoute} = router;
	const {absoluteRedirect} = currentRoute.meta;

	// url without redirect
	if (!absoluteRedirect) {
		return next();
	}

	// url with redirect param, but without absolute path
	if (!absoluteRedirect.match(/^https?:\/\//g)) {
		return next();
	}

	// redirect to absolute path
	if (typeof window !== 'undefined') {
		window.location.href = absoluteRedirect;
	}

	next(false);
}
